import { ConsentCode } from "@/entities/consents"

export enum BooleanField {
    YES = "yes",
    NO = "no",
}

export enum ConsentValue {
    ACCEPTED = "ACCEPTED",
    PENDING = "PENDING",
    REJECTED = "REJECTED",
    UNKNOWN = "UNKNOWN",
}

export const consentCodeParsed = {
    relationalCommunication: "relational_communication",
    commercialCommunication: "commercial_communication",
    personalCommunication: "personal_communication",
}

export const consentOrder = {
    [ConsentCode.MARKETING_PERSONAL_COMMUNICATION]: 1,
    [ConsentCode.MARKETING_RELATIONAL_COMMUNICATION]: 2,
    [ConsentCode.MARKETING_COMMERCIAL_COMMUNICATION]: 3,
}

export const SMSCommunicationPreference = "isOptedInToSmsMessages"
